export const getHiddenMessage = (id, state) => {
  return state.hideMessage.hidenMessages[id] || false;
};
